module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-4d41a5478aa258995b072041d2f609f6.webp";